// extracted by mini-css-extract-plugin
export default {"heading":"_2r2nm2dgmKk1M2RNjE-3RW","body":"_2B5i46nAmK06h5hmaJNegG","closed":"_1mbB9TtSGd7XHsGYmHmouW"};